import angular, { version } from 'angular';
import moment from 'moment';
import URLS from 'Helpers/urls';

(function() {
    'use strict';

    angular.module('app').component('applyModal', {
        template: require('./apply-modal.html'),
        controller: Ctrl,
        controllerAs: 'vm',
        bindings: {
            modalInstance: '<',
            resolve: '<'
        }
    });

    Ctrl.$inject = [
        '$scope',
        '$cookies',
        '$timeout',
        'UploadService',
        'logger',
        'SweetAlert',
        'QueryService'
    ];

    function Ctrl($scope, $cookies, $timeout, UploadService, logger, SweetAlert, QueryService) {
        var vm = this;
        vm.content = null;

        vm.titles = [
            'Part 1 of 6 Passage Reading',
            'Part 2 of 6 Essay Writing',
            'Part 3 of 6 Identifying errors (5 items)',
            'Part 4 of 6 Basic Information',
            'Part 5 of 6 Availability',
            'Part 6 of 6 Introduce yourself!',
        ];
        vm.save_local = save_local;
        vm.upload_audio = upload_audio;
        vm.upload_audio2 = upload_audio2;
        vm.apply = apply;
        vm.close = close;
        vm.data = localStorage.getItem('applicationdata')? JSON.parse(localStorage.getItem('applicationdata')): {};
    
        if(localStorage.getItem('applicationdata')){
            vm.data = JSON.parse(localStorage.getItem('applicationdata'));
            console.log('vm.data');
        }else{
            vm.data = {};
        }

        navigator.getUserMedia = ( navigator.getUserMedia ||
            navigator.webkitGetUserMedia ||
            navigator.mozGetUserMedia ||
            navigator.msGetUserMedia);

        vm.days = ['Su', 'MO', 'TU', 'WE', 'TH', 'FR', 'SA'];
        vm.times = [6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23];


        if(!vm.data.quiz){
            vm.data.quiz = {};
        }

        if(!vm.data.tags){
            vm.data.tags = {};
        }
        if(!vm.data.availability){
            vm.data.availability = [];

            vm.days.forEach((day, x) => {
                vm.data.availability[x] = [];
                vm.times.forEach((time,y) => {
                    vm.data.availability[x][y] = { value: false, time: time, day:day };
                });
            });

        }

        vm.page = 0;

        vm.basic_info = [{
            name: 'Nickname',
            key: 'name'
        },{
            name: 'Phone #',
            key: 'phone',
            placeholder: '+63 939 626 9235'
        },{
            name: 'Email',
            key: 'email'
        },{
            name: 'Kakao ID',
            key: 'kakao_id'
        },{
            name: 'Electric Service Provider',
            key: 'e_esp'
        },{
            name: 'Internet Service Provider',
            key: 'e_isp'
        },{
            name: 'Street',
            key: 'e_street'
        },{
            name: 'More Details',
            key: 'e_street_more'
        },{
            name: 'City',
            key: 'e_city'
        }, {
            name: 'Zipcode',
            key: 'e_zipcode'
        }, {
            name: 'Experience',
            key: 'years_of_experience'
        },{
            name: 'Expertise',
            key: 'expertise'
        }];

        vm.quiz = [{
            name: '1. A <span class="underline">typical Filipino</span><sub class="subscript">(A)</sub> dish, Adobo, <span class="underline">consisting</span><sub class="subscript">(B)</sub> of stir-fried garlic, soy sauce and vinegar as its main source <span class="underline">of</span><sub class="subscript">(C)</sub> flavor, <span class="underline">and</span><sub class="subscript">(D)</sub> pork or chicken as the main part of the dish.',
            index: 0,
        },{
            name: '2. Each year, the Magical Egg, a <span class="underline">mass</span><sub class="subscript">(A)</sub> distributor of chicken eggs, <span class="underline">uses</span><sub class="subscript">(B)</sub> millions of pesos in advertising revenue <span class="underline">annually</span><sub class="subscript">(C)</sub>, but it is rumored that their operations <span class="underline">may</span><sub class="subscript">(D)</sub> stop due to undisclosed circumstances.',                
            index: 1,
        },{
            name: '3. Some industries in Russia <span class="underline">are</span><sub class="subscript">(A)</sub> shifting to eco-friendly alternatives, <span class="underline">which reduces</span><sub class="subscript">(B)</sub> <span class="underline">both</span><sub class="subscript">(C)</sub> air and water pollution <span class="underline">in</span><sub class="subscript">(D)</sub> their vicinity.',
            index: 2,
        },{
            name: '4. PLDT is currently one of the most popular <span class="underline">of all</span><sub class="subscript">(A)</sub> internet service providers in the Philippines, <span class="underline">and is</span><sub class="subscript">(B)</sub> found not only in urban areas <span class="underline">and</span><sub class="subscript">(C)</sub> also in rural <span class="underline">or</span><sub class="subscript">(D)</sub> depopulated areas.',
            index: 3,
        }];

        vm.years_of_experience = [
            'No experience',
            'Less than a year',
            '1 - 2 years',
            '3 - 5 years',
            '5 years or more'
        ];

        vm.tags = [
            'OPIc',
            'TOEFL',
            'TOEIC',
            'Business English',
            'English for Traveling',
            'English for Kids',
            'Freetalking',
            'IELTS',
            'Job Interview Training'
        ].map(s => { return { text: s} });

        vm.upload_image = upload_image;

        vm.save_tags = ()=>{
            console.log(vm.data);
            vm.save_local();
        }

        vm.get_tags = ()=>{

            vm.loading = true;
            var request = {
                method: 'GET',
                route: URLS.base + `/tag`,
                cache: false
            };

            QueryService.query(request)
                .then(
                    function(response) {
                        const data = response.data.data;
                        console.log(data);
                        vm.tags = data.items;

                    },
                    function(error) {}
                )
                .finally(function() { vm.loading = false; }
            );
        }

        vm.get_tags();
        // record stuff
        vm.chunks = [];
        
        navigator.getUserMedia ({ audio: true }, ()=>{

            navigator.mediaDevices.enumerateDevices()
            .then(function(devices) {
                const d = devices.filter(s => s.kind == 'audioinput');
                console.log(d);

                d.forEach(_d => vm.devices.push(_d));
                vm.selected_device = '0';
                $scope.$apply();
            });
        }, ()=>{

        });

        
        init_record();
        function init_record(){

            vm.devices = [];
            vm.selected_device = 0;
            vm.mode = 'stopped';
            vm.record_button_clicked = record_button_clicked;
            vm.start_record = start_record;
            vm.stop_record = stop_record;
            function start_record(){

                const deviceId = vm.devices[vm.selected_device].deviceId;

                window.AudioContext = window.AudioContext || window.webkitAudioContext;

                vm.context = new AudioContext();

                navigator.mediaDevices.getUserMedia({ 
                    audio: { deviceId }
                }).then((stream) => {
                    
                    vm.recorder = new MediaRecorder(stream);
                    vm.recorder.start();


                    vm.recorder.ondataavailable = function(e) {
                        vm.chunks.push(e.data);
                    }
                    
                    vm.recorder.onstop = () => {

                        var audio = document.getElementById('audioplayer');
                        audio.setAttribute('controls', '');
                        audio.controls = true;
                        var blob = new Blob(vm.chunks, { 'type' : 'audio/ogg; codecs=opus' });
                        vm.chunks = [];

                        var audioURL = URL.createObjectURL(blob);
                        audio.src = audioURL;
                        // audio.play();
                        setTimeout(()=>{
                            audio.pause();
                        }, 200);

                        const file = blobToFile(blob,'test.ogg');

                        UploadService.upload(
                            file,
                            'audio/ogg; codecs=opus',
                            { path: 'application_audio', type: file.type },
                            location => {
                                console.log(location);
                                vm.data.application_audio = location;
                                save_local();
                            }
                        )

                        console.log("recorder stopped", audioURL);
                    }
                    
                });

                vm.recording_start = new Date();
                set_timer();


                function blobToFile(theBlob, fileName){
                    return new File([theBlob], fileName, {lastModified: new Date(), type: theBlob.type})
                }
            }

            function stop_record(){
                vm.recorder.stop();
                vm.mode = 'stopped';
                vm.recorded = 1;
            }

            function record_button_clicked(){

                if(vm.data.application_audio){
                    remove_audio();

                }else{
                    start();
                }

                function start(){

                    if(vm.mode === 'stopped'){
                        vm.mode = 'recording';
                        start_record();
                    } else

                    if(vm.mode === 'recording'){
                        vm.mode = 'stopped';
                        stop_record();
                    } 
                }

            }
        }

        function set_timer(){
            const seconds = parseInt((new Date() - vm.recording_start)/1000);
        
            vm.duration = (parseInt(seconds/60)+'').padStart(2, '0') + ':' + (seconds % 60 + '').padStart(2, '0');
        
        
            try{
                $scope.$apply();
            }catch(e){}


            setTimeout(()=>{
                if(vm.mode === 'recording'){
                    set_timer();
                }
            }, 1000);

        }
        // end record

        function upload_image(file, index){

            UploadService.upload(
                file,
                file.type,
                { path: 'application_profile', type: file.type },
                location => {
                    vm.data['profile_' + index] = location;
                    vm.save_local();
                }
            );

        }


        function upload_audio(file){

            UploadService.upload(
                file,
                file.type,
                { path: 'application_profile', type: file.type },
                location => {
                    vm.data['profile_' + index] = location;
                    vm.save_local();
                }
            );

        }

        function upload_audio2(file){

            UploadService.upload(
                file,
                file.type,
                { path: 'application_profile', type: file.type },
                location => {
                    vm.data.audio_introduction = location;
                    vm.save_local();
                }
            );

        }

        // save local
        function save_local(){
            localStorage.setItem('applicationdata', JSON.stringify(vm.data));
        }

        // controls
        vm.clickback = () => {
            if(vm.page === 0) return;

            vm.page = vm.page - 1;
        }

        vm.clickableback = ()=> vm.page != 0;
        vm.clickablenext = ()=> vm.page !== vm.titles.length - 1;

        vm.clicknext = () => {
            if(vm.page === vm.titles.length - 1) return;
            
            vm.page = vm.page + 1;
        }
        function close(){
            vm.modalInstance.close();
        }

        vm.remove_audio=remove_audio;
        function remove_audio(){
            function start(){

                vm.recording_start = new Date();
                set_timer();
                
                var audio = document.getElementById('audioplayer');
                audio.setAttribute('controls', '');
                audio.controls = false;
                
                delete vm.data.application_audio;
                vm.save_local();
            }

            SweetAlert.swal(
                {
                    title: 'Are you sure that you want to delete the previous recording?',
                    text: ``,
                    type: 'warning',
                    confirmButtonText: 'Proceed',
                    cancelButtonText: 'Cancel',
                    showCancelButton: true,
                    closeOnConfirm: true,
                    html: true,
                    closeOnCancel: true
                },
                function(proceed) {
                    if (proceed) {
                        start();
                    }
                }
            );
        }

        vm.click_time = (_time)=>{
            console.log(vm.data.availability);
            let v = true;
            vm.days.forEach((day, x) => {
                vm.times.forEach((time, y) => {
                    
                    if(time == _time){
                        if(vm.data.availability[x][y].value){
                            v = false;
                        }
                    }

                });
            });

            vm.days.forEach((day, x) => {
                vm.times.forEach((time, y) => {
                    if(time == _time){
                        console.log(vm.data.availability[x][y], x, y ,vm.data);
                        vm.data.availability[x][y].value = !!v;
                    }
                });
            });
            save_local();

        }

        vm.click_day = (_day)=>{
            
            let v = true;
            vm.days.forEach((day, x) => {
                vm.times.forEach((time, y) => {
                    if(day == _day){
                        if(vm.data.availability[x][y].value){
                            v = false;
                        }
                    }

                });
            });

            vm.days.forEach((day, x) => {
                vm.times.forEach((time, y) => {
                    
                    if(day == _day){
                        vm.data.availability[x][y].value = !!v;
                    }

                });
            });

            save_local();
        }

        //apply
        function apply(){
            const data = { 
                ...vm.data, 
            };

            const quiz = data.quiz;

            data.availability = JSON.parse(JSON.stringify(vm.data.availability));

            data.username = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5);
            data.password = data.username;
            data.quiz = JSON.stringify(vm.data.quiz);
            data.profile_card = [ data.profile_1, data.profile_2, data.profile_3 ].join('###');


            vm.days.forEach((day, x) => {
                vm.times.forEach((time, y) => {
                    data.availability[x][y] = data.availability[x][y].value;
                });
            });


            data.availability = JSON.stringify(data.availability);


            data.tags = Object.keys(data.tags)
            .filter(k => data.tags[k])
            .map(k => {
                const sss = vm.tags.find(t => t.english_text === k)
                if(sss){
                    return sss.id
                }else{
                    return ''
                }
            });

            const required = [
                { key:"written_input",         page: 2, label: 'ESSAY' },
                { key:"name",                  page: 4, label: 'NAME' },
                { key:"phone",                 page: 4, label: 'PHONE NUMBER' },
                { key:"email",                 page: 4, label: 'EMAIL ADDRESS' },
                { key:"kakao_id",              page: 4, label: 'KAKAO ID' },
                { key:"e_esp",                 page: 4, label: 'ELECTRIC SERVICE PROVIDER' },
                { key:"e_isp",                 page: 4, label: 'INTERNET SERVICE PROVIDER' },
                { key:"e_street",              page: 4, label: 'STREET' },
                { key:"e_city",                page: 4, label: 'CITY' },
                { key:"e_zipcode",             page: 4, label: 'ZIPCODE' },
                { key:"e_street_more",         page: 4, label: 'ADDITIONAL ADDRESS DETAILS' },
                { key:"years_of_experience",   page: 4, label: 'YEARS OF EXPERIENCE' },
                { key:"tags",                  page: 4, label: 'EXPERTISE' },
                { key:"availability",          page: 5, label: 'FREE SCHEDULE' },
                { key:"application_audio",     page: 1, label: 'AUDIO RECORDING' },
                { key:"about_me",              page: 6, label: 'WRITTEN INTRODUCTION' },
                { key:"audio_introduction",    page: 6, label: 'AUDIO INTRODUCTION' }
            ];
            
            // OH NO! YOU FORGOT TO PROVIDE YOUR ____ ON PART _____. 
            // PLEASE UPLOAD THREE PROFILE PICTURES.
            // YOUR APPLICATION IS INCOMPLETE. PLEASE COMPLETE YOUR ANSWERS FOR PART/S ________.

            let missing_count = 0;
            let missing = false;
            let missed;
            let pagesss = {};
            required.forEach(e => {
                const key = e.key;
                console.log('e',e, data[key], key);
                if(!data[key]){
                    missed = e;
                    missing = true;
                    pagesss[e.page] = 1;
                    missing_count++;
                }
            });

            if(missing_count >= 2){
                logger.error(`YOUR APPLICATION IS INCOMPLETE. PLEASE COMPLETE YOUR ANSWERS FOR PART/S ${ Object.keys(pagesss).join(', ')}`)
            }else if(missed){
                logger.error(`OH NO! YOU FORGOT TO PROVIDE YOUR ${ missed.label } ON PART ${ missed.page }`)
            }

            if(!data.profile_1 && !data.profile_2 && !data.profile_3){
                missing = true;
                logger.error(`PLEASE UPLOAD THREE PROFILE PICTURES.`)
            }

            console.log(quiz)
            const quiz_answers = ['quiz_#1', 'quiz_#2', 'quiz_#3', 'quiz_#4'];
            const quiz_texts   = ['quiz_#_text1', 'quiz_#_text2', 'quiz_#_text3', 'quiz_#_text4'];
            
            quiz_answers.forEach((qa, i)=>{
                if(!quiz[qa]){
                    // logger.error(`You forgot to provide an answer for quiz item # `+ (i+1)) + ' in part 3';
                    logger.error('OH NO! YOU FORGOT TO PROVIDE YOUR ANSWER ON QUIZ ITEM # '+ (i+1) +' ON PART 3.');
                    missing = true;
                }
            });
            quiz_texts.forEach((qa, i)=>{
                if(quiz[quiz_answers[i]] !== 'E' && !quiz[qa]){
                    // logger.error(`You have not written an answer for quiz item # `+ (i+1)) + ' in part 3';
                    logger.error('OH NO! YOU FORGOT TO PROVIDE YOUR WRITTEN ANSWER ON QUIZ ITEM # ' + (i+1) + ' ON PART 3.');
                    missing = true;
                    
                }
            });

            if(!quiz['quiz_#_text5']){
                logger.error('OH NO! YOU FORGOT TO PROVIDE YOUR WRITTEN ANSWER ON QUIZ ITEM # 5 ON PART 3.');
                missing = true;
            }else
            if(quiz['quiz_#_text5'].split(' ').length < 35){
                logger.error(`Your answer for quiz item # 5 needs to be 35 words or longer`);
                missing = true;
            }

            if(data.written_input.split(' ').length < 100){
                logger.error(`Your answer for the essay in part 2 must have at least 100 words`);
                missing = true;
            }

            if(!missing){
                send();
            }

            function send(){

                close();

                vm.loading = true;
                var request = {
                    method: 'POST',
                    body: data,
                    route: URLS.base + `/teacher`,
                    cache: false
                };

                QueryService.query(request)
                    .then(
                        function(response) {
                            logger.success('Application Sent!');
                        },
                        function(error) {}
                    )
                    .finally(function() { vm.loading = false; }
                );
            }

        }
    }
})();



// WEBPACK FOOTER //
// ./src/app/components/apply2/apply-modal.component.js